"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LiveSoil;
var jsx_runtime_1 = require("react/jsx-runtime");
var App_1 = require("../../../App");
function LiveSoil() {
    return ((0, jsx_runtime_1.jsx)("img", { id: "soilPackage", alt: "".concat(App_1.keyPhrase, " \u2014 Pacote de Solo Vivo"), src: "https://blog.organolab.com.br/wp-content/uploads/2024/09/kit_super_solo.jpg", width: 375, height: 480, title: "Clique aqui para acessar a p\u00E1gina do produto!", onClick: function () {
            open("https://www.organolab.com.br/kit-solo-vivo", "_self", "noreferrer");
        } }));
}
